import React from 'react';
import { NavLink } from 'react-router-dom';
import UserTypes from '../../utils/userTypes';
import { connect } from 'react-redux';
import { setUserType } from '../../redux/userAuthentication/userAuth.actions';
import { resetToken } from '../../redux/parentDashboard/parentDashboard.actions';

const SideBarElement = ({
	redirectLink,
	PageName,
	isParent,
	setUserType,
	userType,
	containsEmail,
	resetToken,
}) => {
	return (
		<>
			<li>
				<NavLink
					to={redirectLink}
					id={PageName}
					onClick={() => {
						if (!!isParent) {
							setUserType(UserTypes.Parent);
						} else if (userType !== UserTypes.Regular) {
							setUserType(UserTypes.Regular);
							resetToken();
						}
					}}
					activeClassName="active-menu"
				>
					{PageName}
				</NavLink>
			</li>
		</>
	);
};

const mapStateToProps = (state) => {
	const { userType, userEmail, loginId } = state.rootReducer.loginDetails;
	const containsEmail = userEmail?.indexOf("@") !== -1 ? userEmail : loginId?.indexOf("@") !== -1 ? loginId : ''
	return {
		userType,
		containsEmail
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		setUserType: (type) => dispatch(setUserType(type)),
		resetToken: () => dispatch(resetToken()),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(SideBarElement);
